<template>
  <div>
    <div class="relative">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" :rules="rules" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <div>
            <!--            <div v-for="(item,i) in ruleForm" :key="'roomList'+i" style="margin-top: 20px;">-->
            <el-form-item label="考场名称" prop="roomName">
              <el-input v-model="ruleForm.roomName"></el-input>
            </el-form-item>
            <el-form-item label="选择专业级别" prop="gradeIds">
              <el-cascader v-model="ruleForm.gradeIds" :options="gradeTreeDrop.tree" :props="{multiple:true,emitPath:false}" :show-all-levels="true"
                           style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="选择考级点" prop="agentIds">
              <el-cascader v-model="ruleForm.agentIds" :options="agentTreeDrop.tree" :props="{multiple:true,emitPath:false}" :show-all-levels="true"
                           style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="主评官" prop="mainTeacherIds">
              <el-select v-model="ruleForm.mainTeacherIds" placeholder="选择主评官" filterable multiple :multiple-limit="1" style="width: 100%;">
                <el-option v-for="(item,index) in teacherList" :key="index" :label="item.username" :value="item.userId" :class="item.disabled?'none':''"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="副评官" prop="teacherIds">
              <el-select v-model="ruleForm.teacherIds" placeholder="选择副评官" filterable multiple style="width: 100%;">
                <el-option v-for="item in teacherList" :key="item.userId" :label="item.username" :value="item.userId" :class="item.disabled?'none':''"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上午评分人数" prop="amEvaluateLimit">
              <el-input v-model="ruleForm.amEvaluateLimit" maxlength="4" @input="e=>ruleForm.amEvaluateLimit=Tool.checkNumber(e,10000)" placeholder="请输入整数"
                        style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="下午评分人数" prop="pmEvaluateLimit">
              <el-input v-model="ruleForm.pmEvaluateLimit" maxlength="4" @input="e=>ruleForm.pmEvaluateLimit=Tool.checkNumber(e,10000)" placeholder="请输入整数"
                        style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="评分类型" prop="isOnline">
              <el-radio-group v-model="ruleForm.isOnline">
                <el-radio v-for="(enums,key) in Tool.map2arr($enums.isOnline)" :key="key" :label="Number(key)">{{enums.value}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!--          </div>-->
        </div>
      </el-form>
    </div>
    <div class="text-right add-bottom">
      <el-button size="medium" @click="$emit('close')">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row', 'editType', 'room'],
  data () {
    return {
      form: {
        isFillName: 0,
        batchId: this.row,
        roomList: [{ gradeIds: [], agentIds: [], mainTeacherIds: [], teacherIds: [], batchId: this.row, roomName: this.roomName }]
      },
      ruleForm: {},
      teacherIds: [],
      roomNameList: [],
      gradeTreeData: [],
      teacherList: [],
      roomNameDrop: [],
      teacherDrop: {},
      gradeTreeDrop: {},
      agentTreeDrop: {},
      roomName: '',
      rules: {
        roomName: [
          { required: true, message: '请输入考场名称', trigger: 'blur' },
        ],
        gradeIds: [
          { required: true, message: '请选择专业级别', trigger: 'blur' },
        ],
        agentIds: [
          { required: true, message: '请选择考级点', trigger: 'blur' },
        ],
        mainTeacherIds: [
          { required: true, message: '请选择主评官', trigger: 'blur' },
        ],
        teacherIds: [
          { required: true, message: '请选择副评官', trigger: 'blur' },
        ],
        amEvaluateLimit: [
          { required: true, message: '请输入上午评分人数', trigger: 'blur' },
        ],
        pmEvaluateLimit: [
          { required: true, message: '请输入下午评分人数', trigger: 'blur' },
        ],
        isOnline: [
          { required: true, message: '请选择评分类型', trigger: 'blur' },
        ],
      }
    }
  },
  async created () {
    this.teacherList = await this.$HTTP.GradeUser.getList({ batchId: this.row, roomId: this.room })

    let roomNameList = await this.$HTTP.GradeRoom.getList({ batchId: this.row })
    this.roomNameDrop = this.Tool.doDropList({ list: roomNameList }, [], 'roomId')

    let agentTreeData = await this.$HTTP.GradeRoom.getAgentTreeData(this.row)
    this.agentTreeDrop = this.Tool.doDropTree({ tree: agentTreeData }, [], 'value')

    let gradeTreeData = await this.$HTTP.GradeRoom.getGradeTreeData(this.row)
    this.gradeTreeDrop = this.Tool.doDropTree({ tree: gradeTreeData }, [], 'value')


    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    onSelectChange (roomIndex) {
      let oIds = []
      let dropAgentIds = []
      let dropGradeIds = []
      // let rIds = []
      // for (let i in this.form.roomList) {
      //   let group = this.form.roomList[i]
      //   if (!this.Tool.isNull(group.mainTeacherIds)) {
      //     oIds.push(...group.mainTeacherIds)
      //   }
      //   if (!this.Tool.isNull(group.teacherIds)) {
      //     oIds.push(...group.teacherIds)
      //   }
      //   // if (!this.Tool.isNull(group.roomId)) {
      //   //   rIds.push(group.roomId)
      //   // }
      // }
      // this.$forceUpdate()
    },
    async initForm () {
      // let roomList = await this.$HTTP.GradeRoom.getList({ batchId: this.row, isFill: 1 })
      // if (this.Tool.isNull(roomList)) {
      //   this.form.roomList = [{ gradeIds: [], agentIds: [], mainTeacherIds: [], teacherIds: [], batchId: this.row, roomName: this.roomName }]
      // } else {
      //   // for (l
      //   this.form.roomList = roomList
      //   if (this.editType) {
      //     let roomList = await this.$HTTP.GradeRoom.getDetail(this.room)
      //     this.form.roomList = roomList
      //   }
      // }
      if (this.editType) {
        let roomList = await this.$HTTP.GradeRoom.getDetail(this.room)
        roomList.agentIds = roomList.agentIds.split(',')
        roomList.gradeIds = roomList.gradeIds.split(',')
        roomList.teacherIds = roomList.teacherIds.split(',')
        roomList.mainTeacherIds = roomList.mainTeacherIds.split(',')
        this.ruleForm = roomList
      } else {
        this.ruleForm = {
          agentIds: [],
          gradeIds: [],
          teacherIds: [],
          mainTeacherIds: [],
          roomName: '',
          amEvaluateLimit: '',
          pmEvaluateLimit: '',
          isOnline: ''
        }
        // if (this.Tool.isNull(this.ruleForm)) {
        //   this.ruleForm = [{ gradeIds: [], agentIds: [], mainTeacherIds: [], teacherIds: [], batchId: this.row, roomName: this.roomName }]
        // }
      }
      // this.onSelectChange()
      // this.$nextTick(() => {
      //   if (this.$refs['form']) {
      //     this.$refs['form'].clearValidate()
      //   }
      // })
    }
    ,
    checkGroup () {
      let map = new Map()
      for (let i in this.form.roomList) {
        let room = this.form.roomList[i]
        for (let j in room.gradeIds) {
          for (let k in room.agentIds) {
            const str = `${room.gradeIds[j]}--${room.agentIds[k]}`
            if (map.has(str)) {
              throw new Error(`第${Number(map.get(str)) + 1}考场与第${Number(i) + 1}考场中专业级别和考级点重复`)
            } else {
              map.set(str, i)
            }
          }
        }
      }
      return map
    }
    ,
    save () {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          try {
            let params = this.ruleForm
            if (!(Object.prototype.toString.call(params.agentIds) == '[object Array]')) {
              params.agentIds = params.agentIds.split(',')
            }
            if (!(Object.prototype.toString.call(params.mainTeacherIds) == '[object Array]')) {
              params.mainTeacherIds = params.mainTeacherIds.split(',')
            }
            if (!(Object.prototype.toString.call(params.gradeIds) == '[object Array]')) {
              params.gradeIds = params.gradeIds.split(',')
            }
            if (!(Object.prototype.toString.call(params.teacherIds) == '[object Array]')) {
              params.teacherIds = params.teacherIds.split(',')
            }
            if (this.editType) {
              let main = params.mainTeacherIds
              let teacher = params.teacherIds
              if (main instanceof Array && teacher instanceof Array) {
                for (let i = 0, iLen = main.length; i < iLen; i++) {
                  for (let j = 0, jLen = teacher.length; j < jLen; j++) {
                    if (main[i] === teacher[j]) {
                      this.$message({ type: 'warning', message: '主评官与副评官不可重复' })
                      return false;
                    }
                  }
                }
              }
              await this.$HTTP.GradeRoom.updateRoom(params)
              this.$message({ type: 'success', message: '修改成功' })
              this.$emit('close')
            } else {
              this.$set(params, 'batchId', this.row)
              this.$set(params, 'roomId', this.room)
              let main = params.mainTeacherIds
              let teacher = params.teacherIds
              if (main instanceof Array && teacher instanceof Array) {
                for (let i = 0, iLen = main.length; i < iLen; i++) {
                  for (let j = 0, jLen = teacher.length; j < jLen; j++) {
                    if (main[i] === teacher[j]) {
                      this.$message({ type: 'warning', message: '主评官与副评官不可重复' })
                      return false;
                    }
                  }
                }
              }
              await this.$HTTP.GradeRoom.edit(params)
              this.$message({ type: 'success', message: '保存成功' })
              this.$emit('close')
            }
          } catch (e) {
            this.Tool.doError(e)
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
  .add-bottom {
    box-shadow: none;
    padding: 0 20px 20px 0;
  }
</style>
